export const KPI_COL_WIDTH = 100;
export const KPI_LEFT_COL_MAX_WIDTH = 340;
export const KPI_LEFT_COL_MIN_WIDTH = 200;
export const KPI_COL_MARGIN_RIGHT = 4;
export const KPI_HEADER_COL_HEIGHT = 32;
